import { Routes } from '@angular/router';

/**
 * Angular route configuration is not defined statically in `app.routes.ts` but is instead
 * loaded at runtime from the backend (`app_routes` table in the database).
 *
 * This variable defines the primary and nested routes available within the application,
 * specifying paths, components to load, route data, guards, and resolvers to be used.
 *
 * Structure:
 * - `path`: Defines the URL path segment for the route.
 * - `loadComponent`: Lazy-loading function that loads the component associated with the route.
 * - `children`: Optional nested routes for hierarchical navigation.
 * - `data`: Optional route-specific metadata, such as titles.
 * - `canActivate`: Optional array of route guards determining access permissions.
 * - `resolve`: Optional mapping of resolvers to fetch data before route activation.
 * - `runGuardsAndResolvers`: Specifies behavior for guards and resolvers during navigation.
 * - `redirectTo`: For wildcard or fallback routes, redirects to a specified route.
 */
export const APP_ROUTES: Routes = [];
